module.exports = __webpack_public_path__ + "img/aws.c0a63d97.png";